import React from "react";


import {
    PageContainerComponent
} from "@Components/Sections";

import {
    HeadSectionComponent
} from "@Parts/Sections";

import {
    SupportSectionComponent
} from "@Parts/@Support";

import {
    LegalElementsListComponent
} from "@Pages/@LegalPages/@Parts/LegalsElementsList";

import {
    LegalElementsListElementType
} from "@Pages/@LegalPages/@Parts/LegalsElementsList/LegalElement";


import headSectionImage from "./@Images/headSectionImage.svg";


import "./index.scss";


const LegalElementsList: LegalElementsListElementType[] = [
    {
        elementOrderNr: 1,
        elementTitle: 'Who We Are',
        elementContent: `
            <p>Qyvo S.A. is a Polish public limited company (Prosta Spółka Akcyjna, “PSA”) registered in the National Court Register (KRS 0000000000), NIP PL0000000000. Our headquarters and primary place of business is Leśna 1, 81-854 Sopot, Poland. We are the data controller under Regulation (EU) 2016/679 (GDPR). For privacy inquiries contact: privacy@useqyvo.com or our Data Protection Officer (DPO) at dpo@useqyvo.com.</p>
        `
    },
    {
        elementOrderNr: 2,
        elementTitle: 'Scope',
        elementContent: `
            <p>This Privacy Policy applies to visitors of our websites (getqyvo.com, useqyvo.com), users who join our beta or subscribe to our mailing list, and customers who authorise integrations with their inboxes, billing accounts, or other data sources to enable Qyvo’s automated refund‑recovery services.</p>
        `
    },
    {
        elementOrderNr: 3,
        elementTitle: 'Data We Collect & Lawful Bases',
        elementContent: `
            <ul>
                <li>Account (Name, email, hashed password / OAuth token) - Create & secure account (Art 6 (1)(b) Contract)</li>
                <li>Transactional (Flight PNR, receipts, card last 4, refund amounts) - Detect & file refunds (Art 6 (1)(b) Contract)</li>
                <li>Usage (IP, device, event logs) - Security, analytics, debugging (Art 6 (1)(f) Legitimate interests)</li>
                <li>Marketing (Email open/click, referral source) - Send offers w/ consent (Art 6 (1)(a) Consent)</li>
                <li>Sensitive (optional - Inbox message bodies (travel/receipts label only)) - Automated refund detection (Art 6 (1)(a) & Art 9 (2)(a) Explicit consent)</li>
            </ul>    
        `
    },
    {
        elementOrderNr: 4,
        elementTitle: 'How & Why We Use Your Data',
        elementContent: `
            <ul>
                <li>To discover and calculate refund opportunities</li>
                <li>To submit refund or compensation claims in your name via API, web‑form, or email‑send‑as</li>
                <li>To charge success‑fees once a refund is confirmed</li>
                <li>To provide account notifications, receipts, and customer support</li>
                <li>To improve and secure our platform</li>
                <li>To send product updates and marketing where you have opted‑in</li>
            </ul>
        `
    },
    {
        elementOrderNr: 5,
        elementTitle: 'Sub‑Processors & International Transfers',
        elementContent: `
            <p>We rely on vetted sub‑processors such as AWS (EU‑Frankfurt), Stripe Payments (Ireland & USA), Plaid (EU data centre, SCCs), OpenAI (Ireland & USA, SCCs), and Browserless (EU). All US transfers are protected by Standard Contractual Clauses. The up‑to‑date sub‑processor list is appended to our Data Processing Addendum.</p>
        `
    },
    {
        elementOrderNr: 6,
        elementTitle: 'Cookies & Tracking Technologies',
        elementContent: `
            <p>Our sites use:</p>
            <ul>
                <li>Essential cookies (session, CSRF)</li>
                <li>Analytics cookies (Matomo, self‑hosted in EU) — disabled by default until you opt‑in</li>
                <li>Marketing pixels (Meta / Google) — loaded only after consent</li>
            </ul>
            <p>A Cookie‑Preference banner script (CookieConsent v3) is loaded on every page. You may revoke or modify your preferences at any time</p>
            <p></p>
        `
    },
    {
        elementOrderNr: 7,
        elementTitle: 'Data Retention',
        elementContent: `
            <p>Raw inbox and receipt data is retained max 180 days after a claim is closed. Aggregated, non‑identifiable ledger data may be kept for audit and statistical purposes.</p>
        `
    },
    {
        elementOrderNr: 8,
        elementTitle: 'Security & Certifications',
        elementContent: `
            <ul>
                <li>AES‑256 encryption at rest, TLS 1.3 in transit</li>
                <li>Customer OAuth tokens stored in AWS KMS, rotated every 90 days</li>
                <li>ISO 27001‑aligned controls; SOC 2 Type I audit scheduled Q4 2025</li>
            </ul>
        `
    },
    {
        elementOrderNr: 9,
        elementTitle: 'Your Rights',
        elementContent: `
            <p>You can exercise GDPR rights to access, rectify, erase, restrict, object, or port your data by emailing privacy@useqyvo.com or via in‑app settings. We will respond within 30 days.</p>
        `
    },
    {
        elementOrderNr: 10,
        elementTitle: 'Complaints & EU ODR',
        elementContent: `
            <p>You may lodge a complaint with the Polish Data‑Protection Authority (UODO) or use the EU Online Dispute Resolution portal: https://ec.europa.eu/consumers/odr</p>
        `
    },
    {
        elementOrderNr: 11,
        elementTitle: 'Changes to this Policy',
        elementContent: `
            <p>We will email you and post updates 14 days before changes take effect.</p>
        `
    },
];


export const PrivacyPolicyPage:React.FC = () => {

    return (
        <PageContainerComponent pageType={'privacy-policy-page'}>

            <HeadSectionComponent
                pageName={'privacy-policy'}
                sectionHeaderText={'Privacy Policy'}
                sectionSubText={'Last updated: 2025.09.01'}
                sectionImage={headSectionImage}
            />

            <LegalElementsListComponent
                legalPageType={'privacy-policy'}
                legalElementsList={LegalElementsList}
            />

            <SupportSectionComponent />

        </PageContainerComponent>
    );

};


export default PrivacyPolicyPage;
